export const WORKER_URL =
  import.meta.env.VITE_WORKER_URL ?? 'https://instadash-ingest.contact-e0b.workers.dev'
